import axios from "./axios";

const BASKETS_PATH = "/api/broker-gateway/baskets/";
const CLIENT_BASKETS_PATH = "/api/broker-gateway/client-baskets/";
const REMOVE_BASKET_CLIENTS_PATH = "/api/broker-gateway/remove-basket-clients/";

/** @returns {Promise<Array<{ id: string, basket_name: string, description: string|null, clients?: Array<{ name: string, broker_client_code: string, multiplier: number, client_id: number }>, broker_client_codes?: string[], basket_clients?: Array<{ id: string, client_id: number, broker_client_code?: string, multiplier?: number }> }>>} */
export const getBaskets = async (options = {}) => {
  const { signal } = options;
  const { data } = await axios.get(BASKETS_PATH, { signal });
  if (Array.isArray(data?.response)) return data.response;
  if (Array.isArray(data)) return data;
  return [];
};

export const createBasket = async ({ basket_name, description }) => {
  const { data } = await axios.post(BASKETS_PATH, {
    basket_name: String(basket_name ?? "").trim(),
    description:
      description == null || String(description).trim() === ""
        ? null
        : String(description).trim(),
  });
  return data;
};

/**
 * Add clients to a basket with per-client multipliers.
 * @param {{ basket_id: string, client_data: Array<{ client_id: number, multiplier: number }> }} payload
 */
export const addClientsToBasket = async (payload) => {
  const basket_id = String(payload.basket_id ?? "").trim();
  const seen = new Set();
  const client_data = [];
  for (const row of payload.client_data || []) {
    const client_id = Number(row?.client_id);
    if (Number.isNaN(client_id) || seen.has(client_id)) continue;
    seen.add(client_id);
    const multNum = Number(row?.multiplier);
    client_data.push({
      client_id,
      multiplier: Number.isFinite(multNum) && multNum >= 0 ? multNum : 1,
    });
  }
  const { data } = await axios.post(CLIENT_BASKETS_PATH, {
    basket_id,
    client_data,
  });
  return data;
};

/** @param {{ basket_id: string, client_ids: number[] }} payload */
export const removeBasketClients = async (payload) => {
  const basketId = String(payload.basket_id ?? "").trim();
  const clientIds = Array.from(
    new Set(
      (payload.client_ids || [])
        .map((id) => Number(id))
        .filter((n) => !Number.isNaN(n))
    )
  );
  const { data } = await axios.post(REMOVE_BASKET_CLIENTS_PATH, {
    basket_id: basketId,
    client_ids: clientIds,
  });
  return data;
};

export const deleteBasket = async (basketId) => {
  const id = encodeURIComponent(String(basketId).trim());
  const { data } = await axios.delete(`/api/broker-gateway/remove-basket/${id}/`);
  return data;
};
